// Saves made before they moved to the server. Migrated once per account,
// then removed. Fixture mode has no server, so it keeps using this key.
export const LEGACY_SAVED_KEY = 'event_map:saved'

// The key carries no owner, so it must not outlive the session that made it:
// the next account to sign in on this browser would migrate it as its own.
export const clearLegacyEventMapSaves = () => {
  try {
    window.localStorage.removeItem(LEGACY_SAVED_KEY)
  } catch {
    // ignore
  }
}
